import React, { useState } from 'react';
import './Dashboard.css';

// Mock Employee/Form Data for PayrollGen
const mockFormData = {
  personalInfo: {
    employeeId: "EMP-2024-156",
    firstName: "Sarah",
    lastName: "Johnson",
    email: "sarah.johnson@company.com",
    phone: "+1 (555) 987-6543",
    dateOfBirth: "1988-08-20",
    address: "456 Corporate Avenue, Suite 12",
    city: "San Francisco",
    state: "CA",
    zipCode: "94105"
  },
  employmentInfo: {
    designation: "Senior HR Manager",
    department: "Human Resources",
    joiningDate: "2019-06-15",
    employmentType: "Full-Time",
    reportingManager: "Michael Chen",
    workLocation: "Main Office - Building A",
    employeeStatus: "Active"
  },
  salaryInfo: {
    basicSalary: "$95,000",
    hra: "$15,000",
    transportAllowance: "$3,600",
    medicalAllowance: "$2,400",
    specialAllowance: "$8,000",
    totalCTC: "$124,000"
  },
  bankDetails: {
    bankName: "Wells Fargo Bank",
    accountNumber: "1234567890",
    ifscCode: "WFBIUS6S",
    accountType: "Savings",
    branch: "Downtown Branch"
  },
  taxInfo: {
    panNumber: "ABCDE1234F",
    taxDeduction: "30%",
    pfAccountNumber: "PF/CA/1234567",
    esiNumber: "ESI-987654321"
  }
};

const FormDataReview = () => {
  const [formData, setFormData] = useState(mockFormData);
  const [isGenerating, setIsGenerating] = useState(false);

  const handleInputChange = (section, field, value) => {
    setFormData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value
      }
    }));
  };

  const generatePDF = async () => {
    setIsGenerating(true);
    
    // Check if jsPDF is available
    if (typeof window.jspdf === 'undefined') {
      alert('PDF library is loading... Please try again in a moment.');
      setIsGenerating(false);
      return;
    }

    try {
      const { jsPDF } = window.jspdf;
      const doc = new jsPDF();
      
      // Header
      doc.setFillColor(102, 126, 234);
      doc.rect(0, 0, 210, 35, 'F');
      
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(24);
      doc.setFont(undefined, 'bold');
      doc.text('PayrollGen', 105, 15, { align: 'center' });
      
      doc.setFontSize(14);
      doc.setFont(undefined, 'normal');
      doc.text('Employee Information Report', 105, 25, { align: 'center' });
      
      // Reset text color
      doc.setTextColor(0, 0, 0);
      
      let yPosition = 45;
      
      // Personal Information
      doc.setFontSize(16);
      doc.setFont(undefined, 'bold');
      doc.setTextColor(102, 126, 234);
      doc.text('Personal Information', 20, yPosition);
      yPosition += 3;
      doc.setDrawColor(102, 126, 234);
      doc.setLineWidth(0.5);
      doc.line(20, yPosition, 190, yPosition);
      yPosition += 8;
      
      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');
      doc.setTextColor(0, 0, 0);
      
      Object.entries(formData.personalInfo).forEach(([key, value]) => {
        const label = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
        doc.setFont(undefined, 'bold');
        doc.text(`${label}:`, 20, yPosition);
        doc.setFont(undefined, 'normal');
        doc.text(String(value), 80, yPosition);
        yPosition += 6;
      });
      
      yPosition += 5;
      
      // Employment Information
      doc.setFontSize(16);
      doc.setFont(undefined, 'bold');
      doc.setTextColor(102, 126, 234);
      doc.text('Employment Information', 20, yPosition);
      yPosition += 3;
      doc.setDrawColor(102, 126, 234);
      doc.line(20, yPosition, 190, yPosition);
      yPosition += 8;
      
      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');
      doc.setTextColor(0, 0, 0);
      
      Object.entries(formData.employmentInfo).forEach(([key, value]) => {
        const label = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
        doc.setFont(undefined, 'bold');
        doc.text(`${label}:`, 20, yPosition);
        doc.setFont(undefined, 'normal');
        doc.text(String(value), 80, yPosition);
        yPosition += 6;
      });
      
      yPosition += 5;
      
      // Salary Information
      doc.setFontSize(16);
      doc.setFont(undefined, 'bold');
      doc.setTextColor(102, 126, 234);
      doc.text('Salary Information', 20, yPosition);
      yPosition += 3;
      doc.setDrawColor(102, 126, 234);
      doc.line(20, yPosition, 190, yPosition);
      yPosition += 8;
      
      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');
      doc.setTextColor(0, 0, 0);
      
      Object.entries(formData.salaryInfo).forEach(([key, value]) => {
        const label = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
        doc.setFont(undefined, 'bold');
        doc.text(`${label}:`, 20, yPosition);
        doc.setFont(undefined, 'normal');
        doc.text(String(value), 80, yPosition);
        yPosition += 6;
      });
      
      // Add new page if needed
      if (yPosition > 250) {
        doc.addPage();
        yPosition = 20;
      } else {
        yPosition += 5;
      }
      
      // Bank Details
      doc.setFontSize(16);
      doc.setFont(undefined, 'bold');
      doc.setTextColor(102, 126, 234);
      doc.text('Bank Details', 20, yPosition);
      yPosition += 3;
      doc.setDrawColor(102, 126, 234);
      doc.line(20, yPosition, 190, yPosition);
      yPosition += 8;
      
      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');
      doc.setTextColor(0, 0, 0);
      
      Object.entries(formData.bankDetails).forEach(([key, value]) => {
        const label = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
        doc.setFont(undefined, 'bold');
        doc.text(`${label}:`, 20, yPosition);
        doc.setFont(undefined, 'normal');
        doc.text(String(value), 80, yPosition);
        yPosition += 6;
      });
      
      yPosition += 5;
      
      // Tax Information
      doc.setFontSize(16);
      doc.setFont(undefined, 'bold');
      doc.setTextColor(102, 126, 234);
      doc.text('Tax & Compliance Information', 20, yPosition);
      yPosition += 3;
      doc.setDrawColor(102, 126, 234);
      doc.line(20, yPosition, 190, yPosition);
      yPosition += 8;
      
      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');
      doc.setTextColor(0, 0, 0);
      
      Object.entries(formData.taxInfo).forEach(([key, value]) => {
        const label = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
        doc.setFont(undefined, 'bold');
        doc.text(`${label}:`, 20, yPosition);
        doc.setFont(undefined, 'normal');
        doc.text(String(value), 80, yPosition);
        yPosition += 6;
      });
      
      // Footer
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor(128, 128, 128);
        doc.text(
          `Generated on: ${new Date().toLocaleString()} | Page ${i} of ${pageCount}`,
          105,
          285,
          { align: 'center' }
        );
        doc.text('PayrollGen - Confidential Document', 105, 290, { align: 'center' });
      }
      
      // Save the PDF
      const fileName = `Employee_${formData.personalInfo.employeeId}_${new Date().toISOString().split('T')[0]}.pdf`;
      doc.save(fileName);
      
      setTimeout(() => {
        setIsGenerating(false);
      }, 1000);
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Error generating PDF. Please try again.');
      setIsGenerating(false);
    }
  };

  const renderFormSection = (title, section, sectionKey) => {
    return (
      <div className="form-section">
        <h3 className="section-title">{title}</h3>
        <div className="form-grid">
          {Object.entries(section).map(([key, value]) => (
            <div key={key} className="form-field">
              <label className="field-label">
                {key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
              </label>
              <input
                type={key.includes('email') ? 'email' : key.includes('Date') ? 'date' : 'text'}
                value={value}
                onChange={(e) => handleInputChange(sectionKey, key, e.target.value)}
                className="field-input"
              />
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="form-data-review-container">
      <div className="page-header">
        <div>
          <h2 className="page-title">Employee Form Review</h2>
          <p className="page-subtitle">Review employee information and generate PDF report</p>
        </div>
      </div>

      <div className="form-content-wrapper">
        <div className="alert-info">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="16" x2="12" y2="12"/>
            <line x1="12" y1="8" x2="12.01" y2="8"/>
          </svg>
          <span>You can edit any field below before generating the PDF report. All changes are temporary and for preview only.</span>
        </div>

        {renderFormSection('Personal Information', formData.personalInfo, 'personalInfo')}
        {renderFormSection('Employment Information', formData.employmentInfo, 'employmentInfo')}
        {renderFormSection('Salary Information', formData.salaryInfo, 'salaryInfo')}
        {renderFormSection('Bank Details', formData.bankDetails, 'bankDetails')}
        {renderFormSection('Tax & Compliance Information', formData.taxInfo, 'taxInfo')}

        <div className="form-actions">
          <button
            onClick={generatePDF}
            disabled={isGenerating}
            className={`btn-primary ${isGenerating ? 'btn-generating' : ''}`}
          >
            {isGenerating ? (
              <>
                <svg className="spinner" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M12 2a10 10 0 0 1 0 20"/>
                </svg>
                <span>Generating PDF...</span>
              </>
            ) : (
              <>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                  <polyline points="14 2 14 8 20 8"/>
                  <line x1="12" y1="18" x2="12" y2="12"/>
                  <line x1="9" y1="15" x2="15" y2="15"/>
                </svg>
                <span>Generate & Download PDF</span>
              </>
            )}
          </button>
        </div>
      </div>

      {/* Load jsPDF if not already loaded */}
      {typeof window !== 'undefined' && typeof window.jspdf === 'undefined' && (
        <script src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js"></script>
      )}
    </div>
  );
};

export default FormDataReview;
